import {
  SignInSignUpState,
  AuthType,
} from '../../../utils/constants';
import { logInfo, storeSessionData } from '../../../utils';

/**
 * Handles Cognito challenges during sign-in
 * @param {object} output - The sign-in output from Amplify
 * @returns {boolean} true if EMAIL_OTP challenge was handled, false otherwise
 */
export function handleEmailOTPChallenge(output) {
  if (output.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_EMAIL_CODE') {
    logInfo('EMAIL_OTP challenge detected, prompting for email code');
    this.env.signInSignUpState = {
      status: SignInSignUpState.OTP_CONFIRMATION,
      authType: AuthType.CONFIRM_SIGN_IN,
    };
    return true;
  }
  return false;
}

/**
  * Handles SMS_MFA challenge during sign-in
  * @param {object} output - The sign-in output from Amplify
  * @returns {boolean} true if SMS_MFA challenge was handled, false otherwise
 */
export function handleSMSMFAChallenge(output) {
  if (output.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_SMS_CODE') {
    logInfo('SMS_MFA challenge detected, prompting for SMS code');
    this.env.signInSignUpState = {
      status: SignInSignUpState.OTP_CONFIRMATION,
      authType: AuthType.CONFIRM_SIGN_IN,
      codeDeliveryDetails: output.nextStep.codeDeliveryDetails,
    };
    return true;
  }
  return false;
}

/**
 * Handles new password required challenge during sign-in
 * @param {object} output - The sign-in output from Amplify
 * @returns {boolean} true if new password challenge was handled, false otherwise
 */
export function handleNewPasswordRequired(output) {
  if (output.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
    logInfo('New password required challenge detected');
    storeSessionData({
      loginInfo: {
        username: this.loginInfo?.username,
      },
    });
    this.env.history.push('/changePassword');
    return true;
  }
  return false;
}

/**
 * Handles EMAIL_OTP resend challenge
 * @param {object} output - The sign-in output from Amplify
 * @returns {boolean} true if EMAIL_OTP resend was handled, false otherwise
 */
export function handleEmailOTPResend (output) {
  if (output.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_EMAIL_CODE') {
    this.env.signInSignUpState = {
      status: SignInSignUpState.OTP_RESEND,
    };
    return true;
  }
  return false;
}

/**
 * Handles SMS_MFA resend challenge
 * @param {object} output - The sign-in output from Amplify
 * @returns {boolean} true if SMS_MFA resend was handled, false otherwise
 */
export function handleSMSMFAResend (output) {
  if (output.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_SMS_CODE') {
    this.env.signInSignUpState = {
      status: SignInSignUpState.OTP_RESEND,
      codeDeliveryDetails: output.nextStep?.codeDeliveryDetails,
    };
    return true;
  }
  return false;
}
